import API from '../../sunwiseAPI';

const config = { headers: { 'Content-Type': 'application/json' } };
const ENTITY = 'aftersales-project-configuration';

export const create = (data) =>
    API.post(`/api/v1/${ENTITY}/sunpay/`, data, config);
export const fetchData = (uuid) => API.get(`/api/v1/${ENTITY}/${uuid}/sunpay/`);
export const update = (uuid, data) =>
    API.put(`/api/v1/${ENTITY}/${uuid}/sunpay/`, data, config);
